export const DEFAULT_WELCOME_MESSAGE = 'defaultWelcomeMessage';
export const DEFAULT_UNAVAILABLE_MESSAGE = 'defaultUnavailableMessage';
